var path = 'app/scripts/modules/azure/pipeline/stages/destroyAsg/destroyAsgStepLabel.html';
var html = "<span class=\"task-label\">\n  Destroy Server Group:\n  {{step.context.serverGroupName}}\n  ({{step.context.region}})\n</span>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/scripts/modules/azure/pipeline/stages/destroyAsg/destroyAsgStepLabel.html
// module id = 1673
// module chunks = 0